import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ApiTravelMemberHelperService {
  status = [
    { id: 'waiting', name: 'Enregistré', color: 'basic' },
    { id: 'registered', name: 'En attente de validation', color: 'alert' },
    { id: 'accepted', name: 'Inscrit', color: 'accent' },
    { id: 'refused', name: 'Refusé', color: 'warn' },
  ];

  getCivility(travelMember: any, defaultValue = '-') {
    if (travelMember.civility === 'sir') {
      return 'Mr';
    }
    if (travelMember.civility === 'mrs') {
      return 'Mme';
    }
    return defaultValue;
  }

  getFullName(travelMember: any, civility = true) {
    if (!travelMember) {
      return null;
    }

    let result = '',
      comma = '';
    if (civility && travelMember.civility) {
      result += this.getCivility(travelMember);
      comma = ' ';
    }
    if (travelMember.firstName) {
      result += comma + travelMember.firstName;
      comma = ' ';
    }
    if (travelMember.lastName) {
      result += comma + travelMember.lastName;
    }

    return result ? result : 'N/C';
  }

  getStatusName(travelMember: any) {
    const status = this.status.find((item) => item.id == travelMember?.status);
    return status?.name || 'Inconnu';
  }

  getStatusColor(travelMember: any) {
    const status = this.status.find((item) => item.id == travelMember?.status);
    return status?.color || 'accent';
  }
}
